import React from 'react';

interface ToggleSwitchProps {
  isOn: boolean;
  onToggle: (isOn: boolean) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ isOn, onToggle }) => {
  const handleToggle = () => {
    onToggle(!isOn);
  };

  return (
    <div
      onClick={handleToggle}
      style={{
        width: '36px', // Smaller width
        height: '18px', // Smaller height
        borderRadius: '12px', // Adjusted border radius
        backgroundColor: isOn ? '#6277FF' : '#E0E0E0',
        position: 'relative',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
      }}
    >
      <div
        style={{
          width: '14px', // Smaller circle width
          height: '14px', // Smaller circle height
          borderRadius: '50%',
          backgroundColor: '#FFFFFF',
          position: 'absolute',
          top: '2px',
          left: isOn ? '20px' : '2px', // Adjusted position for smaller size
          transition: 'left 0.2s',
          boxShadow: '0px 2px 4px -2px rgba(0, 0, 0, 0.06)',
        }}
      />
    </div>
  );
};

export default ToggleSwitch;